export default __webpack_public_path__ + "7235cc8daf3220be61a281ff520f1273.png";